// This file is auto-generated by @hey-api/openapi-ts

import { type Options, AliveService, AppointmentService, ClinicalNotesExportCallbackService, CountriesService, ExternalDataService, FeatureTogglesService, GeneralIdentityService, GeneralThemeService, IdpAuthenticationService, LanguageService, LanguagesService, LicenceHolderService, RedRobinService, SessionService, SorryService, TimeZonesService, TranslationSetsService, TurnTestService, VerificationAttemptsService, VideoCallBackgroundService } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, type DefaultError } from '@tanstack/react-query';
import type { AliveAliveData, AppointmentGetAccessInfoData, AppointmentGetCalendarInfoData, AppointmentGetVideoCallInfoData, AppointmentGetRedRobinSessionIdData, ClinicalNotesExportCallbackHandleClinicalNotesExportCallbackData, CountriesGetSystemCountriesData, ExternalDataGetExternalDataData, FeatureTogglesGetFeatureTogglesData, FeatureTogglesGetByGlobalCustomerIdData, GeneralIdentitySignOutData, GeneralThemeGetHolderThemeData, IdpAuthenticationChallengeClientData, IdpAuthenticationChallengeOvermindData, LanguageGetSystemLanguagesData, LanguageSetLanguageData, LanguageSetLanguageError, LanguageSetLanguageResponse, LanguagesGetSystemLanguagesData, LicenceHolderGetUrlAliasData, LicenceHolderGetLicenceHolderIdData, LicenceHolderGetOfficeBaseByAliasData, LicenceHolderGetPublicBaseRouteInfoByAliasConsiderDomainData, LicenceHolderGetPublicBaseByAliasConsiderDomainData, LicenceHolderGetPublicBaseByAliasData, LicenceHolderGetPatientPolicyDocumentsData, RedRobinCreateNavigationSessionData, RedRobinCreateNavigationSessionError, RedRobinGetRepresentativeNinData, RedRobinGetSessionData, RedRobinNavigateData, RedRobinNavigateResponse, SessionTouchData, SessionTouch2Data, SorryGetSorryData, TimeZonesGetSystemTimeZonesData, TranslationSetsGetData, TurnTestReportTurnTestData, VerificationAttemptsBeginPhoneVerificationAttemptData, VerificationAttemptsBeginPhoneVerificationAttemptError, VerificationAttemptsBeginPhoneVerificationAttemptResponse, VerificationAttemptsCompleteVerificationAttemptData, VerificationAttemptsCompleteVerificationAttemptError, VerificationAttemptsCompleteVerificationAttemptResponse, VideoCallBackgroundGetData } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const aliveAliveQueryKey = (options?: Options<AliveAliveData>) => createQueryKey('aliveAlive', options);

/**
 * Get information about the currently logged in user.
 *  Defined in VisibaCare.Api.General.Controllers.AliveController
 */
export const aliveAliveOptions = (options?: Options<AliveAliveData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AliveService.aliveAlive({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: aliveAliveQueryKey(options)
    });
};

export const appointmentGetAccessInfoQueryKey = (options: Options<AppointmentGetAccessInfoData>) => createQueryKey('appointmentGetAccessInfo', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.AppointmentController
 */
export const appointmentGetAccessInfoOptions = (options: Options<AppointmentGetAccessInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AppointmentService.appointmentGetAccessInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentGetAccessInfoQueryKey(options)
    });
};

export const appointmentGetCalendarInfoQueryKey = (options: Options<AppointmentGetCalendarInfoData>) => createQueryKey('appointmentGetCalendarInfo', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.AppointmentController
 */
export const appointmentGetCalendarInfoOptions = (options: Options<AppointmentGetCalendarInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AppointmentService.appointmentGetCalendarInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentGetCalendarInfoQueryKey(options)
    });
};

export const appointmentGetVideoCallInfoQueryKey = (options: Options<AppointmentGetVideoCallInfoData>) => createQueryKey('appointmentGetVideoCallInfo', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.AppointmentController
 */
export const appointmentGetVideoCallInfoOptions = (options: Options<AppointmentGetVideoCallInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AppointmentService.appointmentGetVideoCallInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentGetVideoCallInfoQueryKey(options)
    });
};

export const appointmentGetRedRobinSessionIdQueryKey = (options: Options<AppointmentGetRedRobinSessionIdData>) => createQueryKey('appointmentGetRedRobinSessionId', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.AppointmentController
 */
export const appointmentGetRedRobinSessionIdOptions = (options: Options<AppointmentGetRedRobinSessionIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await AppointmentService.appointmentGetRedRobinSessionId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appointmentGetRedRobinSessionIdQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.General.Controllers.ClinicalNotesExportCallbackController
 */
export const clinicalNotesExportCallbackHandleClinicalNotesExportCallbackMutation = (options?: Partial<Options<ClinicalNotesExportCallbackHandleClinicalNotesExportCallbackData>>): UseMutationOptions<unknown, DefaultError, Options<ClinicalNotesExportCallbackHandleClinicalNotesExportCallbackData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ClinicalNotesExportCallbackHandleClinicalNotesExportCallbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await ClinicalNotesExportCallbackService.clinicalNotesExportCallbackHandleClinicalNotesExportCallback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const countriesGetSystemCountriesQueryKey = (options?: Options<CountriesGetSystemCountriesData>) => createQueryKey('countriesGetSystemCountries', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.CountriesController
 */
export const countriesGetSystemCountriesOptions = (options?: Options<CountriesGetSystemCountriesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await CountriesService.countriesGetSystemCountries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countriesGetSystemCountriesQueryKey(options)
    });
};

export const externalDataGetExternalDataQueryKey = (options: Options<ExternalDataGetExternalDataData>) => createQueryKey('externalDataGetExternalData', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.ExternalDataController
 */
export const externalDataGetExternalDataOptions = (options: Options<ExternalDataGetExternalDataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ExternalDataService.externalDataGetExternalData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: externalDataGetExternalDataQueryKey(options)
    });
};

export const featureTogglesGetFeatureTogglesQueryKey = (options?: Options<FeatureTogglesGetFeatureTogglesData>) => createQueryKey('featureTogglesGetFeatureToggles', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.FeatureTogglesController
 */
export const featureTogglesGetFeatureTogglesOptions = (options?: Options<FeatureTogglesGetFeatureTogglesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureTogglesService.featureTogglesGetFeatureToggles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureTogglesGetFeatureTogglesQueryKey(options)
    });
};

export const featureTogglesGetByGlobalCustomerIdQueryKey = (options?: Options<FeatureTogglesGetByGlobalCustomerIdData>) => createQueryKey('featureTogglesGetByGlobalCustomerId', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.FeatureTogglesController
 */
export const featureTogglesGetByGlobalCustomerIdOptions = (options?: Options<FeatureTogglesGetByGlobalCustomerIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await FeatureTogglesService.featureTogglesGetByGlobalCustomerId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: featureTogglesGetByGlobalCustomerIdQueryKey(options)
    });
};

export const generalIdentitySignOutQueryKey = (options?: Options<GeneralIdentitySignOutData>) => createQueryKey('generalIdentitySignOut', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.GeneralIdentityController
 */
export const generalIdentitySignOutOptions = (options?: Options<GeneralIdentitySignOutData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await GeneralIdentityService.generalIdentitySignOut({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: generalIdentitySignOutQueryKey(options)
    });
};

export const generalThemeGetHolderThemeQueryKey = (options: Options<GeneralThemeGetHolderThemeData>) => createQueryKey('generalThemeGetHolderTheme', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.GeneralThemeController
 */
export const generalThemeGetHolderThemeOptions = (options: Options<GeneralThemeGetHolderThemeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await GeneralThemeService.generalThemeGetHolderTheme({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: generalThemeGetHolderThemeQueryKey(options)
    });
};

export const idpAuthenticationChallengeClientQueryKey = (options: Options<IdpAuthenticationChallengeClientData>) => createQueryKey('idpAuthenticationChallengeClient', options);

/**
 *  Defined in VisibaCare.Api.Authentication.IdpAuthenticationController
 */
export const idpAuthenticationChallengeClientOptions = (options: Options<IdpAuthenticationChallengeClientData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await IdpAuthenticationService.idpAuthenticationChallengeClient({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: idpAuthenticationChallengeClientQueryKey(options)
    });
};

export const idpAuthenticationChallengeOvermindQueryKey = (options: Options<IdpAuthenticationChallengeOvermindData>) => createQueryKey('idpAuthenticationChallengeOvermind', options);

/**
 *  Defined in VisibaCare.Api.Authentication.IdpAuthenticationController
 */
export const idpAuthenticationChallengeOvermindOptions = (options: Options<IdpAuthenticationChallengeOvermindData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await IdpAuthenticationService.idpAuthenticationChallengeOvermind({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: idpAuthenticationChallengeOvermindQueryKey(options)
    });
};

export const languageGetSystemLanguagesQueryKey = (options?: Options<LanguageGetSystemLanguagesData>) => createQueryKey('languageGetSystemLanguages', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LanguageController
 */
export const languageGetSystemLanguagesOptions = (options?: Options<LanguageGetSystemLanguagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LanguageService.languageGetSystemLanguages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: languageGetSystemLanguagesQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.General.Controllers.LanguageController
 */
export const languageSetLanguageMutation = (options?: Partial<Options<LanguageSetLanguageData>>): UseMutationOptions<LanguageSetLanguageResponse, LanguageSetLanguageError, Options<LanguageSetLanguageData>> => {
    const mutationOptions: UseMutationOptions<LanguageSetLanguageResponse, LanguageSetLanguageError, Options<LanguageSetLanguageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await LanguageService.languageSetLanguage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const languagesGetSystemLanguagesQueryKey = (options?: Options<LanguagesGetSystemLanguagesData>) => createQueryKey('languagesGetSystemLanguages', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LanguagesController
 */
export const languagesGetSystemLanguagesOptions = (options?: Options<LanguagesGetSystemLanguagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LanguagesService.languagesGetSystemLanguages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: languagesGetSystemLanguagesQueryKey(options)
    });
};

export const licenceHolderGetUrlAliasQueryKey = (options: Options<LicenceHolderGetUrlAliasData>) => createQueryKey('licenceHolderGetUrlAlias', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LicenceHolderController
 */
export const licenceHolderGetUrlAliasOptions = (options: Options<LicenceHolderGetUrlAliasData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LicenceHolderService.licenceHolderGetUrlAlias({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: licenceHolderGetUrlAliasQueryKey(options)
    });
};

export const licenceHolderGetLicenceHolderIdQueryKey = (options: Options<LicenceHolderGetLicenceHolderIdData>) => createQueryKey('licenceHolderGetLicenceHolderId', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LicenceHolderController
 */
export const licenceHolderGetLicenceHolderIdOptions = (options: Options<LicenceHolderGetLicenceHolderIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LicenceHolderService.licenceHolderGetLicenceHolderId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: licenceHolderGetLicenceHolderIdQueryKey(options)
    });
};

export const licenceHolderGetOfficeBaseByAliasQueryKey = (options: Options<LicenceHolderGetOfficeBaseByAliasData>) => createQueryKey('licenceHolderGetOfficeBaseByAlias', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LicenceHolderController
 */
export const licenceHolderGetOfficeBaseByAliasOptions = (options: Options<LicenceHolderGetOfficeBaseByAliasData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LicenceHolderService.licenceHolderGetOfficeBaseByAlias({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: licenceHolderGetOfficeBaseByAliasQueryKey(options)
    });
};

export const licenceHolderGetPublicBaseRouteInfoByAliasConsiderDomainQueryKey = (options?: Options<LicenceHolderGetPublicBaseRouteInfoByAliasConsiderDomainData>) => createQueryKey('licenceHolderGetPublicBaseRouteInfoByAliasConsiderDomain', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LicenceHolderController
 */
export const licenceHolderGetPublicBaseRouteInfoByAliasConsiderDomainOptions = (options?: Options<LicenceHolderGetPublicBaseRouteInfoByAliasConsiderDomainData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LicenceHolderService.licenceHolderGetPublicBaseRouteInfoByAliasConsiderDomain({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: licenceHolderGetPublicBaseRouteInfoByAliasConsiderDomainQueryKey(options)
    });
};

export const licenceHolderGetPublicBaseByAliasConsiderDomainQueryKey = (options?: Options<LicenceHolderGetPublicBaseByAliasConsiderDomainData>) => createQueryKey('licenceHolderGetPublicBaseByAliasConsiderDomain', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LicenceHolderController
 */
export const licenceHolderGetPublicBaseByAliasConsiderDomainOptions = (options?: Options<LicenceHolderGetPublicBaseByAliasConsiderDomainData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LicenceHolderService.licenceHolderGetPublicBaseByAliasConsiderDomain({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: licenceHolderGetPublicBaseByAliasConsiderDomainQueryKey(options)
    });
};

export const licenceHolderGetPublicBaseByAliasQueryKey = (options: Options<LicenceHolderGetPublicBaseByAliasData>) => createQueryKey('licenceHolderGetPublicBaseByAlias', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LicenceHolderController
 */
export const licenceHolderGetPublicBaseByAliasOptions = (options: Options<LicenceHolderGetPublicBaseByAliasData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LicenceHolderService.licenceHolderGetPublicBaseByAlias({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: licenceHolderGetPublicBaseByAliasQueryKey(options)
    });
};

export const licenceHolderGetPatientPolicyDocumentsQueryKey = (options: Options<LicenceHolderGetPatientPolicyDocumentsData>) => createQueryKey('licenceHolderGetPatientPolicyDocuments', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.LicenceHolderController
 */
export const licenceHolderGetPatientPolicyDocumentsOptions = (options: Options<LicenceHolderGetPatientPolicyDocumentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await LicenceHolderService.licenceHolderGetPatientPolicyDocuments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: licenceHolderGetPatientPolicyDocumentsQueryKey(options)
    });
};

/**
 * This is used by RedRobin to create a navigation session when a session is initiated from the RedRobin side.
 * Example: FlowMedic, KioskDemo app.
 *  Defined in VisibaCare.Api.General.Controllers.RedRobinController
 */
export const redRobinCreateNavigationSessionMutation = (options?: Partial<Options<RedRobinCreateNavigationSessionData>>): UseMutationOptions<unknown, RedRobinCreateNavigationSessionError, Options<RedRobinCreateNavigationSessionData>> => {
    const mutationOptions: UseMutationOptions<unknown, RedRobinCreateNavigationSessionError, Options<RedRobinCreateNavigationSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await RedRobinService.redRobinCreateNavigationSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const redRobinGetRepresentativeNinQueryKey = (options: Options<RedRobinGetRepresentativeNinData>) => createQueryKey('redRobinGetRepresentativeNin', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.RedRobinController
 */
export const redRobinGetRepresentativeNinOptions = (options: Options<RedRobinGetRepresentativeNinData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await RedRobinService.redRobinGetRepresentativeNin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: redRobinGetRepresentativeNinQueryKey(options)
    });
};

export const redRobinGetSessionQueryKey = (options: Options<RedRobinGetSessionData>) => createQueryKey('redRobinGetSession', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.RedRobinController
 */
export const redRobinGetSessionOptions = (options: Options<RedRobinGetSessionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await RedRobinService.redRobinGetSession({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: redRobinGetSessionQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.General.Controllers.RedRobinController
 */
export const redRobinNavigateMutation = (options?: Partial<Options<RedRobinNavigateData>>): UseMutationOptions<RedRobinNavigateResponse, DefaultError, Options<RedRobinNavigateData>> => {
    const mutationOptions: UseMutationOptions<RedRobinNavigateResponse, DefaultError, Options<RedRobinNavigateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await RedRobinService.redRobinNavigate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sessionTouchQueryKey = (options?: Options<SessionTouchData>) => createQueryKey('sessionTouch', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.SessionController
 */
export const sessionTouchOptions = (options?: Options<SessionTouchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SessionService.sessionTouch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sessionTouchQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.General.Controllers.SessionController
 */
export const sessionTouch2Mutation = (options?: Partial<Options<SessionTouch2Data>>): UseMutationOptions<unknown, DefaultError, Options<SessionTouch2Data>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SessionTouch2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await SessionService.sessionTouch2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sorryGetSorryQueryKey = (options?: Options<SorryGetSorryData>) => createQueryKey('sorryGetSorry', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.SorryController
 */
export const sorryGetSorryOptions = (options?: Options<SorryGetSorryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await SorryService.sorryGetSorry({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sorryGetSorryQueryKey(options)
    });
};

export const timeZonesGetSystemTimeZonesQueryKey = (options?: Options<TimeZonesGetSystemTimeZonesData>) => createQueryKey('timeZonesGetSystemTimeZones', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.TimeZonesController
 */
export const timeZonesGetSystemTimeZonesOptions = (options?: Options<TimeZonesGetSystemTimeZonesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await TimeZonesService.timeZonesGetSystemTimeZones({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: timeZonesGetSystemTimeZonesQueryKey(options)
    });
};

export const translationSetsGetQueryKey = (options: Options<TranslationSetsGetData>) => createQueryKey('translationSetsGet', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.TranslationSetsController
 */
export const translationSetsGetOptions = (options: Options<TranslationSetsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await TranslationSetsService.translationSetsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: translationSetsGetQueryKey(options)
    });
};

/**
 *  Defined in VisibaCare.Api.General.Controllers.TurnTestController
 */
export const turnTestReportTurnTestMutation = (options?: Partial<Options<TurnTestReportTurnTestData>>): UseMutationOptions<unknown, DefaultError, Options<TurnTestReportTurnTestData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<TurnTestReportTurnTestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await TurnTestService.turnTestReportTurnTest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.General.Controllers.VerificationAttemptsController
 */
export const verificationAttemptsBeginPhoneVerificationAttemptMutation = (options?: Partial<Options<VerificationAttemptsBeginPhoneVerificationAttemptData>>): UseMutationOptions<VerificationAttemptsBeginPhoneVerificationAttemptResponse, VerificationAttemptsBeginPhoneVerificationAttemptError, Options<VerificationAttemptsBeginPhoneVerificationAttemptData>> => {
    const mutationOptions: UseMutationOptions<VerificationAttemptsBeginPhoneVerificationAttemptResponse, VerificationAttemptsBeginPhoneVerificationAttemptError, Options<VerificationAttemptsBeginPhoneVerificationAttemptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await VerificationAttemptsService.verificationAttemptsBeginPhoneVerificationAttempt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 *  Defined in VisibaCare.Api.General.Controllers.VerificationAttemptsController
 */
export const verificationAttemptsCompleteVerificationAttemptMutation = (options?: Partial<Options<VerificationAttemptsCompleteVerificationAttemptData>>): UseMutationOptions<VerificationAttemptsCompleteVerificationAttemptResponse, VerificationAttemptsCompleteVerificationAttemptError, Options<VerificationAttemptsCompleteVerificationAttemptData>> => {
    const mutationOptions: UseMutationOptions<VerificationAttemptsCompleteVerificationAttemptResponse, VerificationAttemptsCompleteVerificationAttemptError, Options<VerificationAttemptsCompleteVerificationAttemptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await VerificationAttemptsService.verificationAttemptsCompleteVerificationAttempt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const videoCallBackgroundGetQueryKey = (options?: Options<VideoCallBackgroundGetData>) => createQueryKey('videoCallBackgroundGet', options);

/**
 *  Defined in VisibaCare.Api.General.Controllers.VideoCallBackgroundController
 */
export const videoCallBackgroundGetOptions = (options?: Options<VideoCallBackgroundGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await VideoCallBackgroundService.videoCallBackgroundGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: videoCallBackgroundGetQueryKey(options)
    });
};